export default function AnchorTarget({ id, offset = 0 }) {
    if (!id) return null;

    return (
        <div
            id={id}
            style={{ top: offset, position: "absolute", left: 0 }}
        ></div>
    );
}
